module.exports = __webpack_public_path__ + "static/img/institution04.7ba1fea.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/institution04.png
// module id = Q1Zt
// module chunks = 1